// @flow

import React, { type Node, type ElementType } from 'react';
import styled from 'styled-components';

import { HighlightBox } from '../../../../../commons/atoms';
import { theme } from '../../../../../commons/theme';

export const VoucherNumberWrapper = styled.p`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  word-break: break-all;
  text-align: center;
`;

type Props = {
  children: Node,
  as?: ElementType,
};

export function VoucherNumber({ children, as='span', ...rest }: Props): Node {
  return (
    <VoucherNumberHighlightBox {...rest} as={as}>
      {children}
    </VoucherNumberHighlightBox>
  );
}

const VoucherNumberHighlightBox = styled(HighlightBox)`
  font-family: ${theme.fontFamily.display};
  font-size: 1.3em;
  font-weight: 700;
  padding: ${props => (props.compact ? '0' : '0.2em 0.6em')};
  margin: ${props => (props.compact ? '0' : '0.2em')};
`;
